(() => {
  const cartRoute = window.themeRoutes?.cart || '/cart';
  const currency = window.themeCurrency || 'EUR';

  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency,
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2
  }).format(cents / 100);

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[name="quantity"]');
    const form = control.closest('form');
    const total = form?.querySelector('[data-button-total]');
    const buyButton = form?.querySelector('[data-unit-price]');
    const unitPrice = Number(buyButton?.dataset.unitPrice || 0);

    const updateTotal = () => {
      const quantity = Math.min(9, Math.max(1, Number(input.value) || 1));
      input.value = quantity;
      if (total) total.textContent = formatMoney(unitPrice * quantity);
    };

    control.querySelector('[data-decrease]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value) - 1);
      updateTotal();
    });

    control.querySelector('[data-increase]')?.addEventListener('click', () => {
      input.value = Math.min(9, Number(input.value) + 1);
      updateTotal();
    });

    input.addEventListener('change', updateTotal);
  });

  document.querySelectorAll('[data-direct-checkout-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const variantId = form.querySelector('input[name="id"]')?.value;
      const quantity = Math.min(9, Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value) || 1));
      const button = form.querySelector('[data-buy-now]');
      const message = form.querySelector('[data-product-form-message]');

      if (!variantId) {
        if (message) message.textContent = 'Please select an available product.';
        return;
      }

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      const normalizedCartRoute = cartRoute.endsWith('/') ? cartRoute.slice(0, -1) : cartRoute;
      window.location.assign(`${normalizedCartRoute}/${encodeURIComponent(variantId)}:${quantity}?checkout`);
    });
  });

  document.querySelectorAll('[data-scroll-buy]').forEach((button) => {
    button.addEventListener('click', () => {
      const purchaseForm = document.querySelector('[data-direct-checkout-form]');
      const fallback = document.querySelector('[data-product-section]');
      (purchaseForm || fallback)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => purchaseForm?.querySelector('[data-buy-now]')?.focus(), 450);
    });
  });
})();
